<div class="container">
  <div class="column-list-container">
    <div class="column-list">
      <mat-list>
        @if (selectionColumn; as selectColumn) {
          <mat-list-item>
            <div
              [matTooltip]="'SELECTION_COLUMN_VISIBILITY_LOCKED' | transloco"
            >
              <button
                matIconButton
                disabled
                [attr.aria-label]="'VISIBILITY' | transloco"
              >
                <mat-icon>visibility</mat-icon>
              </button>
            </div>
            <button
              mat-icon-button
              [matTooltip]="'PINNING' | transloco"
              (click)="onClickPinSelectionToggle(selectColumn)"
            >
              @if (getPinIconName(selectColumn); as icon) {
                @if (icon === 'pin_off') {
                  <mat-icon svgIcon="pin_off"></mat-icon>
                } @else {
                  <mat-icon>{{ icon }}</mat-icon>
                }
              }
            </button>
            <div
              class="ellipsis"
              [matTooltip]="'SELECTION' | transloco"
              transloco="SELECTION"
            ></div>
          </mat-list-item>
        }
        @for (column of gridColumns; track column) {
          <mat-list-item>
            <button
              mat-icon-button
              [matTooltip]="'VISIBILITY' | transloco"
              (click)="onClickToggleVisibility(column)"
            >
              <mat-icon>{{
                column.isVisible() ? 'visibility' : 'visibility_off'
              }}</mat-icon>
            </button>
            <button
              mat-icon-button
              [matTooltip]="'PINNING' | transloco"
              (click)="onClickPinToggle(column)"
            >
              @if (getPinIconName(column); as icon) {
                @if (icon === 'pin_off') {
                  <mat-icon svgIcon="pin_off"></mat-icon>
                }
                @if (icon !== 'pin_off') {
                  <mat-icon>{{ icon }}</mat-icon>
                }
              }
            </button>
            @if (getColumnName(column); as name) {
              <div class="ellipsis" [matTooltip]="name">
                {{ name }}
              </div>
            }
          </mat-list-item>
        }
      </mat-list>
    </div>
  </div>
  <div class="column-controls-container">
    <mat-action-list>
      <button
        mat-list-item
        class="column-control"
        [matTooltip]="'SHOW_ALL_COLUMNS' | transloco"
        matTooltipPosition="left"
        (click)="onClickShowAllColumns()"
      >
        <mat-icon>visibility</mat-icon>
      </button>
      <button
        mat-list-item
        class="column-control"
        [matTooltip]="'HIDE_ALL_COLUMNS' | transloco"
        matTooltipPosition="left"
        (click)="onClickHideAllColumns()"
      >
        <mat-icon>visibility_off</mat-icon>
      </button>
      <button
        mat-list-item
        class="column-control"
        [matTooltip]="'UNPIN_ALL_COLUMNS' | transloco"
        matTooltipPosition="left"
        (click)="onClickUnPinAllColumns()"
      >
        <mat-icon>push_pin</mat-icon>
      </button>
      <button
        mat-list-item
        class="column-control"
        [matTooltip]="'FIT_TO_COLUMN_WIDTH' | transloco"
        matTooltipPosition="left"
        (click)="onClickFitToColumnWidth()"
      >
        <mat-icon>align_horizontal_center</mat-icon>
      </button>
      <button
        mat-list-item
        class="column-control"
        [matTooltip]="'REMOVE_ALL_SORTS' | transloco"
        matTooltipPosition="left"
        (click)="onClickRemoveAllSorts()"
      >
        <mat-icon>sort</mat-icon>
      </button>
      <button
        mat-list-item
        class="column-control"
        [matTooltip]="'RESET_LAYOUT' | transloco"
        matTooltipPosition="left"
        (click)="onClickResetLayout()"
      >
        <mat-icon>view_column</mat-icon>
      </button>
      <button
        mat-list-item
        class="column-control"
        [matTooltip]="'FILTER_ALL_OFF' | transloco"
        matTooltipPosition="left"
        (click)="onClickClearAllFilters()"
      >
        <mat-icon>filter_alt_off</mat-icon>
      </button>
    </mat-action-list>
  </div>
</div>
